exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ContactForm__wrapper___381je {\n  margin-top: 50px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "ContactForm__wrapper___381je"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ContactForm/ContactForm.css
// module id = 380
// module chunks = 0